import React, { useState, useEffect } from "react"
import { Table, Button, message } from "antd";
import { connect } from 'react-redux'
import InspectionApi from '@api/inspectionnew'
import { getStationData } from '@utils/common'
import moment from 'moment'
import SearchForm from '@components/SearchForm'
import './index.scss'

const Message = (props) => {
  const [loading, setLoading] = useState(false)
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10
  })
  const [selectList, setSelectList] = useState([])
  const [messageList, setMessageList] = useState([])
  const [total, setTotal] = useState(0)

  const [inputList] = useState([{
    label: '消息标题:',
    name: "msgTitle",
    message: "请输入消息标题",
    span: 8,
    labelCol: 6
  }])

  const [dateSearch] = useState([{
    label: '时间',
    name: 'times',
    span: 8,
    labelCol: 6,
    showTime: true,
    tag: 'rangePicker'
  }])

  const columns = [
    {
      title: '消息标题',
      dataIndex: 'msgTitle',
      align: 'center',
      key: 'msgTitle'
    },
    {
      title: '消息内容',
      dataIndex: 'msgContent',
      align: 'center',
      key: 'msgContent'
    },
    // {
    //   title: '发送人',
    //   dataIndex: 'sendUserName',
    //   align: 'center',
    //   key: 'sendUserName'
    // },
    // {
    //   title: '接收人',
    //   dataIndex: 'receiveUserName',
    //   align: 'center',
    //   key: 'receiveUserName'
    // },
    {
      title: '创建时间',
      dataIndex: 'createAt',
      align: 'center',
      key: 'createAt'
    },
    {
      title: '阅读状态',
      dataIndex: 'isRead',
      align: 'center',
      key: 'isRead',
      render: _t => _t ? '已读' : '未读'
    },
    {
      title: '操作',
      key: 'operation',
      width: 100,
      fixed: 'right',
      render: (record) => {
        return (
          record.isRead == 0 && <Button style={{ marginLeft: '5px' }} onClick={() => readStatus(record.id)} size='small' type='primary'>阅读</Button>
        )
      }
    }
  ]

  useEffect(() => {
    // const stationList = getStationData(props.userInfo.stationIds, props.userInfo.stationAliasName)
    setSelectList([
      {
        attr: { allowClear: true },
        label: '是否已读:',
        name: "isRead",
        message: "请选择是否已读",
        options: [{ title: '未读', value: 0 }, { title: '已读', value: 1 }],
        span: 8,
        labelCol: 6
      },
      // {
      //   attr: { allowClear: true },
      //   label: '发送人:',
      //   name: "sendUserId",
      //   message: "请选择发送人",
      //   options: [],
      //   span: 8,
      //   labelCol: 6
      // },
      // {
      //   attr: { allowClear: true },
      //   label: '接收人:',
      //   name: "receiveUserId",
      //   message: "请选择接收人",
      //   options: [],
      //   span: 8,
      //   labelCol: 6
      // }
    ])
  },[])

  useEffect(() => {
    listByRole()
    return () => { }
  }, [searchParams])

  const listByRole = () => {
    setLoading(true)
    InspectionApi.messageListPage({ ...searchParams }).then(res => {
      setLoading(false)
      setMessageList(res.data.data)
      setTotal(res.data.total)
    })
  }

  const readStatus = (id) => {
    InspectionApi.messageRead({id}).then(res => {
      message.success('已读')
      listByRole()
    })
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  }


  const search = (paramsObj) => {
    if (paramsObj.times) {
      paramsObj.beginTime = moment(paramsObj.times[0]._d).format('YYYY-MM-DD HH:mm:ss')
      paramsObj.endTime = moment(paramsObj.times[1]._d).format('YYYY-MM-DD HH:mm:ss')
    }
    paramsObj.msgTitle ? paramsObj.msgTitle : delete paramsObj.msgTitle
    delete paramsObj.times
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1
    }
    setSearchParams(params)
  }

  return (
    <div className="sysMsg-container">
      <SearchForm span={6} inputList={inputList} selectList={selectList}  dateSearch={dateSearch} onSearch={search} />
      <Table
        className='Table'
        scroll={{ x: columns.length * 200 }}
        columns={columns}
        dataSource={messageList}
        rowKey={ record => record.id}
        pagination={{
          current: searchParams.pageNum,
          pageSize: searchParams.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: total => `共${total}条数据`,
          total: total
        }}
        onChange={handleTableChange}
        loading={loading}
      />
    </div>
  )

}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
}

export default connect(mapStateToProps)(Message)